module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.user) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "membership-card"
  }, [_c('div', {
    staticClass: "membership-top"
  }, [_c('h2', [_vm._v(_vm._s(_vm.locale.text_membership_card_title))])]), _vm._v(" "), _c('div', {
    staticClass: "membership-bottom"
  }, [_c('b', [_vm._v(_vm._s(_vm.full_name))]), _vm._v(" "), _c('br'), _c('b', [_vm._v(_vm._s(_vm.locale.text_membership_number_prefix + ' ' + _vm.$root.auth.user_id))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.locale.text_membership_card_children_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.participants), function(participant) {
    return _c('li', [_vm._v(_vm._s([participant.first_name, participant.last_name].join(' ')))])
  }))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f69bbe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Membership/Membership.vue
// module id = 164
// module chunks = 0